import { createIcon } from "@chakra-ui/react";

export const Printer = createIcon({
  displayName: "Printer",
  viewBox: "0 0 32 33",
  d: "M8 .26c-2.206 0-4 1.794-4 4v6h4v-6h14.169L24 6.093v4.169h4V6.092a4.001 4.001 0 0 0-1.169-2.831L25 1.429A4.001 4.001 0 0 0 22.169.261H8zm16 22v6H8v-6h16zm4 2h2c1.106 0 2-.893 2-2v-6c0-2.206-1.794-4-4-4H4c-2.206 0-4 1.795-4 4v6c0 1.107.894 2 2 2h2v4c0 2.207 1.794 4 4 4h16c2.206 0 4-1.793 4-4v-4zm-1-8.5a1.5 1.5 0 1 1 0 3.001 1.5 1.5 0 0 1 0-3z"
});

export default Printer;
